<!--
  Author: Gary Hammock
  Version: 0.1.0
  Description: An error page to handle soft-404s.
-->

<template>
  <div class="http404">
    <h1 class="border-bottom mb-4">
      Error 404 - Resource Not Found
    </h1>
    <b-img
      fluid
      :rounded="true"
      alt="404 'fail' image"
      title="404 'fail' image"
      src="/assets/img/fail.png"
    />
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
